import { GGCoinClient } from "@developerz.ai/ggcoin-sdk";

/**
 * Build one client per browser session. The base URL comes from
 * `VITE_API_BASE_URL` and falls back to the dev-proxy path `/api`. Tests
 * construct `GGCoinClient` directly with a stub fetch.
 */
export function buildClient(jwt: string | null = null): GGCoinClient {
  // A blank or whitespace-only `VITE_API_BASE_URL` (common when an env var is
  // declared but left empty) must NOT pass through `??` — it would misroute
  // every request to a relative empty base. Treat it as unset and fall back to
  // the dev-proxy path.
  const configured = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  const baseUrl = configured ? configured : "/api";
  return new GGCoinClient({ baseUrl, jwt: jwt ?? undefined });
}
